export interface NavItem {
  label: string;
  path: string;
}

export const navItems: NavItem[] = [
  { label: '首页', path: '/' },
  { label: '赛事黑榜', path: '/category/blacklist' },
  { label: '赛事资讯', path: '/category/news' },
  { label: '搜索', path: '/search' },
  { label: '关于', path: '/about' },
];